var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgValuepropsReturn2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  stroke: "#333",
  strokeWidth: 0.25,
  d: "M16.286 4.875a4.839 4.839 0 1 1 0 9.679H4.766l2.483 2.482v.001l.071.087a.56.56 0 0 1 0 .61l-.071.086a.555.555 0 0 1-.696.072l-.087-.072-3.429-3.428a.555.555 0 0 1 0-.784l3.429-3.428.087-.072a.555.555 0 0 1 .696.072l.071.087a.56.56 0 0 1 0 .609l-.071.087-2.483 2.483h11.52a3.732 3.732 0 0 0 0-7.464H7.715a.554.554 0 0 1 0-1.107z"
})));
export default SvgValuepropsReturn2;